import { render, staticRenderFns } from "./SwapTokenDetails.vue?vue&type=template&id=3dab4f2f&scoped=true"
import script from "./SwapTokenDetails.vue?vue&type=script&lang=ts"
export * from "./SwapTokenDetails.vue?vue&type=script&lang=ts"
import style0 from "./SwapTokenDetails.vue?vue&type=style&index=0&id=3dab4f2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dab4f2f",
  null
  
)

export default component.exports